import { createSlice } from "@reduxjs/toolkit"

const initialState: {
  profile: Metricate.UserProfile
  team: Metricate.Team
  darkMode: "0" | "1"
  userInfo: {}
} = {
  profile: {
    id: 0,
    entity_no: "",
    email: "",
    name: "",
    job_title: "",
    job_level: "",
    job_level_name: "",
    tier: {
      label: null,
      color: null,
    },
    profile_img: "",
    region: "",
    wins: null,
    losses: null,
    badges: 0,
    bio: null,
    birthday: null,
    start_date: "",
    team: "",
    incentive_category: "",
    skill: null,
    division: "",
    company: "",
    manager: "",
    service_team: null,
    agent_skill: null,
    department: "",
    discovery_team: "",
    cost_center: "",
    badge_collection: [],
    permissions: [],
    roles: [],
  },
  team: {
    team: [],
    team_rank: 0,
  },
  darkMode: null,
  userInfo: {},
}

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      state.profile = action.payload
    },
    setUserTeam: (state, action) => {
      state.team = action.payload
    },
    setUserDarkMode: (state, action) => {
      state.darkMode = action.payload
    },
    clearUser: () => {
      return { ...initialState }
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload
    },
  },
})

export const { setUserProfile, setUserTeam, setUserDarkMode, clearUser, setUserInfo } = userSlice.actions
export default userSlice.reducer
